module.exports = __webpack_public_path__ + "static/media/whatsapp_logo_transparent.1b67398c.png";